<template>
  <div @click.stop="() => {}" class="popup-prize">
    <div class="prize-contents">
      <!-- 开奖 -->
      <div v-if="prizeVal === 'open'" class="gifts-desc">
        <img class="cover" :src="prizeImage | filterPicture" />
        <h5>{{ prizeName }}</h5>
      </div>
      <!-- 中奖 -->
      <div v-else-if="prizeVal > 0" class="gifts-desc">
        <div class="form">
          <h5 class="one-line" style="margin-top: .8rem">{{ prizeName }}</h5>
          <span>恭喜您中奖啦，请选择选择领奖地点后确认领取！</span>
          <div class="prize-field-inner">
            <van-field @click="addressVisible = true" v-model="addressName" placeholder="选择领取地址" disabled />
          </div>
        </div>
        <h6>— 请至“个人中心”查看 —</h6>
      </div>
      <!-- 没中奖 -->
      <div v-else class="gifts-desc-fail">
        <img src="/dg3/static/emoji/72x72/1f62d.svg">
        <h5>{{ prizeVal == -1 ? '哦豁，本轮奖品已派光光啦' : '哦豁，您与奖品擦肩而过' }}</h5>
        <h5>{{ prizeVal == -1 ? '下次好运哦~' : '再接再厉哦~' }}</h5>
      </div>
    </div>
    <div v-if="prizeVal > 0" @click="submitAddress" class="gifts-btn">
      <span>确认领取</span>
      <img src="/dg3/static/assets/popup-btn.png" />
    </div>
    <div v-else @click="handlePrize" class="gifts-btn">
      <span>{{ prizeVal === 'open' ? '点击抽奖' : '我知道了' }}</span>
      <img src="/dg3/static/assets/popup-btn.png" />
    </div>

    <van-popup v-model="addressVisible" position="bottom">
      <van-picker show-toolbar :columns="room.addressList" @confirm="onAddressConfirm" @cancel="addressVisible = false" value-key="value" />
    </van-popup>
  </div>
</template>

<script>
export default {
  props: ['popup', 'room', 'user'],

  data () {
    return {
      addressName: '',
      addressVisible: false,
    }
  },
 
  computed: {
    prizeVal () {
      return this.popup.ext[0]
    },

    prizeName () {
      return this.popup.ext[1]
    },

    prizeImage () {
      return this.popup.ext[2]
    }
  },

  methods: {
    handlePrize () {
      if (this.prizeVal !== 'open') {
        if (this.prizeVal > 0 && this.room.prizeReceiveType === 'express') {
          this.$router.push({ path: '/coupon/' + this.prizeVal })
        }
        
        this.$store.commit('closePopup')
        return
      }

      this.$store.commit('closePopup')

      this.toast.loading({ duration: 0, message: '', forbidClick: true })

      this.request({
        url: '/liveReceive/receivePrize',
        data: { liveSendId: this.popup.id },
      }).then(res => {
        this.toast.clear()

        setTimeout(() => {
          this.$store.commit('changePopupVisible', {
            id: this.popup.id,
            visible: true,
            status: 'gifts', 
            ext: [res.result, this.prizeName, this.prizeImage]
          })
        }, 500)
      })
    },

    onAddressConfirm (row) {
      this.addressName = row.value
      this.addressVisible = false
    },

    submitAddress () {
      if (!this.addressName) return this.toast('请选择领取地址')
      this.toast.loading({ duration: 0, message: '', forbidClick: true })

      this.request({
        url: '/liveReceive/receivePrizeConfirm',
        data: { liveReceiveId: this.prizeVal, receiveAddress: this.addressName }
      }).then(res => {
        this.toast('领取奖品成功')
        this.$store.commit('closePopup')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-prize {
  display: flex;
  flex-direction: column;
  align-items: center;
  .prize-contents {
    position: relative;
    width: 100%;
    height: 8.06rem;
    background: url(/dg3/static/assets/prize-draw.png) no-repeat;
    background-size: 100%;
    .gifts-desc {
      margin-top: 2.7rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      .cover {
        height: 3rem;
        z-index: 1;
      }
      .form {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        overflow: hidden;
        height: 3.7rem;
        z-index: 1;
        span {
          margin-bottom: .3rem;
          max-width: 4rem;
          color: #999;
        }
      }
      h5 {
        margin-top: .2rem;
        width: 4.2rem;
      }
      h6 {
        margin-top: .5rem;
        font-size: .24rem;
        line-height: .24rem;
        color: #F7931E;
      }
    }
    .gifts-desc-fail {
      margin-top: 3.6rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        margin-bottom: .4rem;
        width: 1.5rem;
      }
    }
    h5 {
      margin-bottom: .15rem;
      text-align: center;
      font-size: .32rem;
      line-height: .36rem;
      color: #D32F43;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .gifts-btn {
    position: relative;
    width: 4rem;
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #D32F43;
      font-size: .4rem;
    }
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
.prize-field-inner {
  display: flex;
  align-items: center;
  padding: 0 .32rem;
  height: .76rem;
  background-color: #F5F5F5;
  border-radius: .12rem;
  .van-cell {
    background-color: transparent;
    .van-field__control:disabled {
      color: #666;
    }
  }
}
</style>